<template>
    <div class="size-guide-text" v-if="frontImages.length > 0">
        <p>
            <strong class="text-bold mr-3">{{ model.nome }}</strong>
            <span v-if="model.altura && model.altura > 0"
                >Altura: {{ parseFloat(model.altura / 100).toFixed(2) }} m</span
            >
            <span v-if="model.busto && model.busto > 0">
                | {{ model.gender === 'F' ? 'Busto' : 'Tórax' }}: {{ model.busto }} cm</span
            >
            <span v-if="model.cintura && model.cintura > 0">
                | Cintura: {{ model.cintura }} cm</span
            >
            <span v-if="model.quadril && model.quadril > 0">
                | Quadril: {{ model.quadril }} cm</span
            >
            <span v-if="model.idade && model.idade > 0"> | Idade: {{ model.idade }} anos</span>
        </p>

        <div>
            <div class="d-flex w-full">
                <ul
                    :id="`size-guide-list-${frontImages[0].modelo_id}`"
                    style="flex: 100%"
                    class="size-guide-list horizontal-list no-scrollbar"
                    @scroll="scrollEvent = $event"
                >
                    <div
                        v-if="videoModelo"
                        class="size-guide-list-item"
                        style="flex: 0 0 200px; margin-right: 0.5rem"
                    >
                        <SizeGuideVideoV2 :model="model" :video="videoModelo"></SizeGuideVideoV2>
                    </div>
                    <div
                        v-for="image in frontImages"
                        :key="image.id"
                        v-if="image.url"
                        class="size-guide-list-item images"
                    >
                        <SizeGuideImageV2
                            :product-type-id="productTypeId"
                            :image="image"
                            :sizes="sizes"
                            @show-zoom="$emit('show-zoom', model, image.size_id)"
                        />
                    </div>
                </ul>
            </div>
            <HorizontalScrollbar
                :scroll-event="scrollEvent"
                :button-height="200"
                :id-list="`size-guide-list-${frontImages[0].modelo_id}`"
            />
        </div>
    </div>
</template>

<script>
    import SizeGuideVideoV2 from './SizeGuideVideoV2.vue';
    import SizeGuideImageV2 from './SizeGuideImageV2.vue';
    import HorizontalScrollbar from '../common/container/HorizontalScrollbar.vue';
    import SelectField from '@bit/chicorei.chicomponents.input.select-field';

    export default {
        name: 'SizeGuideModelV2',
        components: { SelectField, HorizontalScrollbar, SizeGuideImageV2, SizeGuideVideoV2 },

        props: {
            model: {
                type: Object,
                required: true,
            },
            selectedSize: {
                type: Number,
            },
            productTypeId: {
                type: Number,
                required: true,
            },
            sizes: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                scrollEvent: null,
            };
        },

        computed: {
            frontImages() {
                return this.model.images
                    .filter((image) => {
                        if (!this.selectedSize) {
                            return image.type_id === 1;
                        }
                        return image.type_id === 1 && image.size_id === this.selectedSize;
                    })
                    .sort((a, b) =>
                        this.sizes[parseInt(a.size_id)].order >=
                        this.sizes[parseInt(b.size_id)].order
                            ? 1
                            : -1
                    );
            },

            videoModelo() {
                return this.model.images.find((image) => image.main_video === 1);
            },
        },
    };
</script>